import CryptoJS from "crypto-js";
//解密啊
const decrypt = (data: any) => {
  if (!data) return;
  const aesKey = process.env.VUE_APP_AESKEY;
  const key = CryptoJS.enc.Utf8.parse(aesKey);
  // let iv = "35e5cd2d684e5c65b3684d3a1b7cfe0b";
  let iv = process.env.VUE_APP_IV;
  iv = CryptoJS.enc.Utf8.parse(iv);
  const decrypted = CryptoJS.AES.decrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  // let result = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8))
  const result = decrypted.toString(CryptoJS.enc.Utf8);
  try {
    const objResult = JSON.parse(result);
    return objResult;
  } catch (error) {
    return result;
  }
};

export const encrypt = (data: any) => {
  let stringData = data;
  if (typeof data === "object") {
    try {
      stringData = JSON.stringify(data);
    } catch {
      //
    }
  }
  const aesKey = process.env.VUE_APP_AESKEY;
  const key = CryptoJS.enc.Utf8.parse(aesKey);
  let iv = process.env.VUE_APP_IV;
  iv = CryptoJS.enc.Utf8.parse(iv);
  // const dataHex = CryptoJS.enc.Utf8.parse(data);
  const encrypted = CryptoJS.AES.encrypt(stringData, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};
export default decrypt;
